import { render } from "./ProfileCardModal.vue?vue&type=template&id=dead4228&scoped=true"
import script from "./ProfileCardModal.vue?vue&type=script&lang=ts"
export * from "./ProfileCardModal.vue?vue&type=script&lang=ts"

import "./ProfileCardModal.vue?vue&type=style&index=0&id=dead4228&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-dead4228"

export default script